<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="this.$store.state.isRTL ? '' : ' me-sm-6'"
    >
      <li class="text-sm breadcrumb-item" :class="textWhite">
        <a
          v-if="this.$store.state.isRTL"
          :class="textWhite"
          class="opacity-5 ps-2"
          href="#"
          >لوحات القيادة</a
        >
        <a v-else :class="textWhite" class="opacity-8" href="#">当前页</a>
      </li>
      <li
        class="text-sm breadcrumb-item active"
        :class="textWhite ? 'text-white' : 'text-dark'"
        aria-current="page"
      >
        {{ title(currentPage) }}
      </li>
    </ol>
    <h6 class="mb-0 font-weight-bolder" :class="textWhite ? 'text-white' : ''">
      {{ title(currentPage) }}
    </h6>
  </nav>
</template>

<script>
export default {
  name: "breadcrumbs",
  props: {
    currentPage: {
      required: true,
    },
    textWhite: {
      type: String,
    },
  },
  methods:{
    title(textTitle){
      if (textTitle === 'Profile') {
        return '平台简介'
      }else if (textTitle === 'Dashboard') {
        return '数据看板'
      }else if (textTitle === 'Users') {
        return '账号管理'
      }else if (textTitle === 'Merchants') {
        return '商户管理'
      }else if (textTitle === 'Submission') {
        return '进件管理'
      }else if (textTitle === 'Statistic') {
        return '经营数据'
      }else if (textTitle === 'Devices') {
        return '设备管理'
      }else if (textTitle === 'Administrators') {
        return '后台账号'
      } else {
        return textTitle
      }
    }
  }
};
</script>
